
import React, { useState, useEffect, useCallback } from 'react';
import GenericPopup from '../../genericpopup';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';
import serviceApi from '../../../services/serviceApi';
import environment from '../../../environments/environment';

// Set up PDF.js worker
// pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

const AssignmentContent: React.FC = () => {
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  // const [filteredDates, setFilteredDates] = useState<string[]>([]); // no longer needed; backend returns filtered results
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState('');
  const [rangeQueried, setRangeQueried] = useState(false);
  const [submittedAssignments, setSubmittedAssignments] = useState<string[]>([])
  const [submittedAttachments, setSubmittedAttachments] = useState<{ [assignmentTitle: string]: { title: string, attachmentUrl: string, type: 'file' | 'camera' }[] }>({});
  const [cameraStream, setCameraStream] = useState<MediaStream | null>(null);
  const [cameraPopupOpen, setCameraPopupOpen] = useState(false);
  const [pendingAttachments, setPendingAttachments] = useState<{ [assignmentTitle: string]: { title: string, attachmentUrl: string, type: 'file' | 'camera' } | null }>({});
  const [todayAssignments, setTodayAssignments] = useState<Array<{
    title: string;
    description: string;
    adate: string;
    cdate: string;
    subject?: string;
    attachments?: Array<{ title: string; attachmentUrl: string }>;
  }>>([]);

  const [rangeAssignments, setRangeAssignments] = useState<Array<{
    title: string;
    description: string;
    adate: string;
    cdate: string;
    subject?: string;
    attachments?: Array<{ title: string; attachmentUrl: string }>;
  }>>([]); const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [subjectList, setSubjectList] = useState<string[]>([]);
  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState<{ title: string, attachmentUrl: string } | null>(null);
  // const [pdfError, setPdfError] = useState<string | null>(null);
  // const [numPages, setNumPages] = useState<number | null>(null);
  // const [pageNumber, setPageNumber] = useState<number>(1);


  const getEffectiveClass = (): string => {
    try {
      const s = localStorage.getItem('selectedStudent');
      return s ? (JSON.parse(s)?.clss || 'I-A') : 'I-A';
    } catch {
      return 'I-A';
    }
  };
  const formatDateForApi = (date: string) => {
    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
  };

  const Assignments = async (params: {
    date?: string;
    endDate?: string;
    entityStatusFlg?: boolean;
  }) => {
    const response = await serviceApi.get(environment.assignments, params);
    return response;
  };

  const extractSubjects = (data: any[]) => {
    return Array.from(
      new Set(
        data
          .map((it: any) => it.subject)
          .filter((s: any) => typeof s === 'string' && s.trim() !== '')
      )
    );
  };

  const fetchAssignmentsForDate = useCallback(async (date: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const formattedDate = formatDateForApi(date);

      const responseData = await Assignments({
        date: formattedDate,
        endDate: formattedDate,
      });

      const assignments = responseData?.dataList ?? [];
      setSubjectList(extractSubjects(assignments));



      const normalized = assignments.map((it: any) => ({
        title: it.title || 'Untitled',
        description: it.description || '',
        adate: it.adate,
        cdate: it.closing_date,
        subject: it.subject || '',
        attachments: [],
      }));

      setTodayAssignments(normalized);
      // setRangeAssignments([]);
      // setRangeQueried(false);

    } catch (err) {
      setError('Failed to fetch assignments');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleGoClick = async () => {
    if (!fromDate || !toDate) {
      setShowErrorPopup(true);
      return;
    }

    setIsLoading(true);
    setError(null);
    setRangeQueried(true);

    try {
      const responseData = await Assignments({
        date: formatDateForApi(fromDate),
        endDate: formatDateForApi(toDate),
        entityStatusFlg: true,
      });

      const assignments = responseData?.dataList2 ?? [];
      setSubjectList(extractSubjects(assignments));

      const normalized = assignments.map((it: any) => ({
        title: it.title || 'Untitled',
        description: it.description || '',
        adate: it.adate,
        cdate: it.closing_date,
        subject: it.subject || '',
        attachments: [],
      }));

      const filtered = selectedSubject
        ? normalized.filter((it: any) => it.subject === selectedSubject)
        : normalized;

      setRangeAssignments(filtered);

      // setTodayAssignments([]);

    } catch (err) {
      setError('An error occurred');
    } finally {
      setIsLoading(false);
    }
  };
  // --- PRESERVED LOGIC FROM PREVIOUS VERSIONS ---

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setSelectedDate(today);
    setFromDate(today);
    setToDate(today);
    fetchAssignmentsForDate(today);
  }, []);


  useEffect(() => {
    if (selectedDate) {
      fetchAssignmentsForDate(selectedDate);
    }
  }, [selectedDate, fetchAssignmentsForDate]);

  const handleSubmitClick = (title: string) => {
    setSelectedAssignment(title);
    setShowSubmitPopup(true)
  };

  const handleFileUpload = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,application/pdf,.pdf';
    input.onchange = () => {
      if (input.files && input.files.length > 0) {
        const file = input.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileUrl = e.target?.result as string;
          const newAttachment = { title: file.name, attachmentUrl: fileUrl, type: 'file' as const };
          if (selectedAssignment) {
            setPendingAttachments(prev => ({ ...prev, [selectedAssignment]: newAttachment }));
          }
          setShowSubmitPopup(false);
        };
        reader.readAsDataURL(file);
      }
    };
    input.click();
  };

  const handleCameraCapture = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraStream(stream);
      setCameraPopupOpen(true);
    } catch (err) {
      alert('Cannot access camera.');
    }
  };

  const captureImage = () => {
    if (!cameraStream) return;
    const video = document.getElementById('camera-video') as HTMLVideoElement;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d')?.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = canvas.toDataURL('image/png');
    const newAttachment = { title: `Camera - ${new Date().toLocaleString()}`, attachmentUrl: imageData, type: 'camera' as const };
    if (selectedAssignment) {
      setPendingAttachments(prev => ({ ...prev, [selectedAssignment]: newAttachment }));
    }
    cameraStream.getTracks().forEach(track => track.stop());
    setCameraStream(null);
    setCameraPopupOpen(false);
  };

  const handleApprovePending = (assignmentTitle: string) => {
    const pending = pendingAttachments[assignmentTitle];
    if (!pending) return;
    setSubmittedAttachments(prev => ({ ...prev, [assignmentTitle]: [...(prev[assignmentTitle] || []), pending] }));
    setPendingAttachments(prev => ({ ...prev, [assignmentTitle]: null }));
    setSubmittedAssignments(prev => ([...prev, assignmentTitle]));
  };

  const handleRejectPending = (assignmentTitle: string) => {
    setPendingAttachments(prev => ({ ...prev, [assignmentTitle]: null }));
  };

  const formatToDisplay = (dateStr: string) => {
    const raw = (dateStr || '').trim();
    if (!raw) return '';
    const parts = raw.split(' ');
    const datePart = parts[0] || '';
    const sep = datePart.includes('/') ? '/' : '-';
    const [d, m, y] = datePart.split(sep);
    if (!d || !m || !y) return raw;
    return `${d}-${m}-${y}${parts[1] ? ` ${parts[1]}` : ''}${parts[2] ? ` ${parts[2]}` : ''}`.trim();
  };

  const isPdfFile = (url: string) => url.toLowerCase().includes('.pdf') || url.startsWith('data:application/pdf');
  const isImageFile = (url: string) => url.startsWith('data:image/') || /\.(jpg|jpeg|png|gif|webp)$/i.test(url);

  const handleAttachmentClick = (attachment: { title: string, attachmentUrl: string }) => {
    if (isPdfFile(attachment.attachmentUrl)) {
      window.open(attachment.attachmentUrl, "_blank");
      return;
    }
    setSelectedAttachment(attachment);
    setShowAttachmentPopup(true);
  };

  const renderAttachmentPreview = (attachment: { title: string, attachmentUrl: string }) => {
    if (isPdfFile(attachment.attachmentUrl)) {
      return (
        <div className="attachment-preview pdf-preview" onClick={() => handleAttachmentClick(attachment)}>
          <i className="fa-solid fa-file-pdf pdf-icon"></i>
        </div>
      );
    } else if (isImageFile(attachment.attachmentUrl)) {
      return (
        <div className="attachment-preview image-preview" onClick={() => handleAttachmentClick(attachment)}>
          <img src={attachment.attachmentUrl} alt={attachment.title} className="attachment-thumbnail" />
        </div>
      );
    }
    return null;
  };

  const parseBackendDateToDate = (dateStr: string): Date | null => {
    const raw = (dateStr || '').trim();
    if (!raw) return null;
    const parts = raw.split(' ');
    const [d, m, y] = parts[0].split(parts[0].includes('/') ? '/' : '-').map(s => parseInt(s, 10));
    if (!d || !m || !y) return null;
    const date = new Date(y, m - 1, d, 23, 59);
    return date;
  };

  const isPastDeadline = (deadlineStr: string) => {
    const deadline = parseBackendDateToDate(deadlineStr);
    return deadline ? new Date() > deadline : false;
  };

  const renderTodayAssignments = () => {
    return (
      <div className='event-container'>
        <h3 className='title-text'>Assignments for Today</h3>
        {error && <p className='error-text'>{error}</p>}
        <ul className='events-list'>
          {!error && todayAssignments.length > 0 ? todayAssignments.map((ass, idx) => (
            <li key={idx} className='event-item'>
              <strong className="subtitle-text">{ass.title}</strong><br />
              <span className='event-description'>{ass.description}</span><br />
              <span className='event-date'><i className='fa-regular fa-clock colorOrange'></i> Given: {formatToDisplay(ass.adate)}</span><br />
              <span className='event-date'><i className='fa-solid fa-hourglass-half colorOrange'></i> Deadline: {formatToDisplay(ass.cdate)}</span>
              {ass.attachments && <div className="attachment-section">{ass.attachments.map((a, i) => <div key={i}>{renderAttachmentPreview(a)}</div>)}</div>}
              <div className="submit-row">
                <button className='submit-btn' onClick={() => handleSubmitClick(ass.title)} disabled={isPastDeadline(ass.cdate)}>
                  {isPastDeadline(ass.cdate) ? 'Closed' : 'Submit'}
                </button>
                {pendingAttachments[ass.title] && (
                  <div className="pending-attachment">
                    {renderAttachmentPreview(pendingAttachments[ass.title]!)}
                    <div className="pending-actions">
                      <button onClick={() => handleRejectPending(ass.title)}>❌</button>
                      <button onClick={() => handleApprovePending(ass.title)}>✅</button>
                    </div>
                  </div>
                )}
              </div>
              {submittedAttachments[ass.title] && submittedAttachments[ass.title].length > 0 && (
                <div className="submitted-section">
                  <div className="submitted-attachments">
                    {submittedAttachments[ass.title].map((attachment, attIdx) => (
                      <div key={attIdx}>
                        {renderAttachmentPreview(attachment)}
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </li>
          )) : (!error && <p>No assignments for today</p>)}
        </ul>
      </div>
    );
  };

  return (
    <>
      {showErrorPopup && <GenericPopup isOpen={showErrorPopup} title="Error" message="Select From/To dates" type="alert" onClose={() => setShowErrorPopup(false)} />}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay__content">
            <div className="spinner spinner--lg"></div>
            <span className="loading-text">Loading assignments...</span>
          </div>
        </div>
      )}
      {showAttachmentPopup && selectedAttachment && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header"><h3>{selectedAttachment.title}</h3><button onClick={() => setShowAttachmentPopup(false)}>&times;</button></div>
            <div className="attachment-popup-content"><img src={selectedAttachment.attachmentUrl} className="attachment-image" /></div>
          </div>
        </div>
      )}
      <div className='date-picker-container'>
        <button className='date-nav-btn' onClick={() => {
          const d = new Date(selectedDate); d.setDate(d.getDate() - 1); setSelectedDate(d.toISOString().split('T')[0]);
        }}><i className="fa-solid fa-chevron-left"></i></button>
        <input type='date' value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} className='date-input' />
        <button className='date-nav-btn' onClick={() => {
          const d = new Date(selectedDate); d.setDate(d.getDate() + 1); setSelectedDate(d.toISOString().split('T')[0]);
        }}><i className="fa-solid fa-chevron-right"></i></button>
      </div>

      {renderTodayAssignments()}

      <div className="filter-section">
        <label>From:</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => {
            setFromDate(e.target.value);
            setRangeQueried(false);
          }}
          className="filter-date-input"
        />

        <label>To:</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => {
            setToDate(e.target.value);
            setRangeQueried(false);
          }}
          className="filter-date-input"
        />

        <label>Subject:</label>
        <select
          value={selectedSubject}
          onChange={(e) => {
            setSelectedSubject(e.target.value);
            setRangeQueried(false);
          }}
          className="filter-subject-dropdown"
        >
          <option value="">All Subjects</option>
          {subjectList.map((subj, idx) => (
            <option key={idx} value={subj}>
              {subj}
            </option>
          ))}
        </select>

        <button
          className="go-button"
          onClick={handleGoClick}
        >
          Go
        </button>
      </div>

      {rangeQueried && rangeAssignments.length > 0 && (
        <div className='event-container'>
          <h3 className='title-text'>
            Assignments from {formatDateForApi(fromDate)} to {formatDateForApi(toDate)}
          </h3>
          <ul className='events-list'>
            {rangeAssignments.map((ass, idx) => (
              <li key={idx} className='event-item'>
                {/* <strong>{ass.title}</strong><br /> */}
                <strong className="subtitle-text">{ass.title}</strong><br />
                <span className='event-description'>{ass.description}</span><br />
                <span className='event-date'>
                  <i className='fa-regular fa-clock colorOrange'></i>  Given on: {formatToDisplay(ass.adate)}
                </span>
                <br />
                <span className='event-date'>
                  <i className='fa-solid fa-hourglass-half colorOrange'></i>  Submission deadline: {formatToDisplay(ass.cdate)}
                </span>

                {ass.attachments && ass.attachments.length > 0 && (
                  <div className="attachment-section">
                    {ass.attachments.map((attachment, attIdx) => (
                      <div key={attIdx}>
                        {renderAttachmentPreview(attachment)}
                      </div>
                    ))}
                  </div>
                )}

                <div className="submit-row">
                  <button className='submit-btn' onClick={() => handleSubmitClick(ass.title)} disabled={isPastDeadline(ass.cdate)}>
                    {isPastDeadline(ass.cdate) ? 'Submission closed' : 'Submit'}
                  </button>
                  {pendingAttachments[ass.title] && (
                    <div className="pending-attachment">
                      {renderAttachmentPreview(pendingAttachments[ass.title] as { title: string, attachmentUrl: string })}
                      <div className="pending-actions">
                        <button className="reject-btn" title="Reject" onClick={() => handleRejectPending(ass.title)}>❌</button>
                        <button className="approve-btn" title="Approve" onClick={() => handleApprovePending(ass.title)}>✅</button>
                      </div>
                    </div>
                  )}
                </div>

                {submittedAttachments[ass.title] && submittedAttachments[ass.title].length > 0 && (
                  <div className="submitted-section">
                    <div className="submitted-attachments">
                      {submittedAttachments[ass.title].map((attachment, attIdx) => (
                        <div key={attIdx}>
                          {renderAttachmentPreview(attachment)}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      {showSubmitPopup && (
        <GenericPopup isOpen={showSubmitPopup} title='Submit' type='custom' onClose={() => setShowSubmitPopup(false)}>
          <div className='popup-actions'>
            <button className="yes-btn" onClick={handleFileUpload}><i className="fas fa-upload"></i> File</button>
            <button className="yes-btn" onClick={handleCameraCapture}><i className="fas fa-camera"></i> Camera</button>
          </div>
        </GenericPopup>
      )}

      {cameraPopupOpen && cameraStream && (
        <GenericPopup
          isOpen={cameraPopupOpen}
          title="Camera Capture"
          type="custom"
          onClose={() => {
            cameraStream.getTracks().forEach(track => track.stop());
            setCameraStream(null);
            setCameraPopupOpen(false);
          }}
        >
          <video
            id="camera-video"
            autoPlay
            playsInline
            muted
            className="camera-video"
            ref={videoEl => {
              if (videoEl && cameraStream) {
                videoEl.srcObject = cameraStream;
              }
            }}
          />
          <div className="popup-actions popup-actions-margin">
            <button className="yes-btn" onClick={captureImage}>📸 Capture</button>
            <button
              className="no-btn"
              onClick={() => {
                cameraStream.getTracks().forEach(track => track.stop());
                setCameraStream(null);
                setCameraPopupOpen(false);
              }}
            >
              Cancel
            </button>
          </div>
        </GenericPopup>
      )}
    </>
  );
};

export default AssignmentContent;